module.exports = __webpack_public_path__ + "media/components/country-flag/static/ss-0e68883cba47868e5e0f6918bae25ef0.svg";